/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import { AnyFunction, IsUndefined } from 'types';

export type CompOrNode = ReactNode | ((p: any) => JSX.Element);

type ComponentProps<T> =
  Extract<T, AnyFunction> extends AnyFunction
    ? IsUndefined<Parameters<Extract<T, AnyFunction>>[0]> extends true
      ? unknown
      : Parameters<Extract<T, AnyFunction>>[0]
    : unknown;

type ComponentOrNodeProps<T extends CompOrNode> = {
  target: T;
} & ComponentProps<T>;

/**
 * Handle a dynamic renderer of
 * something that could be either a React component or a ReactNode
 *
 * Fully typed!
 */
export function ComponentOrNode<T extends CompOrNode>({
  target,
  ...props
}: ComponentOrNodeProps<T>) {
  if (typeof target !== 'function') return <>{target}</>;

  const Target = target as () => JSX.Element;

  return <Target {...props} />;
}
